export function getConditionCategories(conditionObj) {
  return conditionObj?.categories || []
}

export function getVisitCategories(visitObj) {
  return (visitObj?.conditions || []).flatMap(getConditionCategories)
}
